import { ApiMethod } from 'services/api';

/** Input types that can be displayed within the form */
export enum Inputs {
  /** Booleans */
  Checkbox = 'checkbox',
  /** Basic string or number values, or comma-separated list of values */
  Input = 'input',
  /** Convert comma-separated list into (string | number)[] arrays */
  TextArea = 'textArea',
}

/** Action details used on successful form submission */
export type Action = {
  /** Function to be run with the successful response from the endpoint */
  onClick: (data?: any) => void;
  /** Button label for action, defaults to Download */
  title: string;
};

export type Options = {
  [key: string]: {
    /** default value for input or checkbox, falls back to `false` for checkbox and `''` for input */
    default?: boolean | string | number;
    /** Help text displayed below input from FormField */
    helpText?: string;
    /** Custom label text */
    label?: string;
    /** Additional text displayed in the FormField */
    restrictionText?: string;
    /** Type of input to display */
    type: Inputs;
  };
};

export interface Endpoint {
  /** Action to be taken on successful form submit */
  actions?: Action[];
  /** Provided as `id` for inputs and form field associations */
  key: string;
  /** method used for API */
  method: ApiMethod;
  /** object containing all of the form inputs */
  opts: Options;
  /** the route associated with the post request */
  route: string;
}
